/* BB BATTLE BANDS — bb-bands.js */
(function () {
  'use strict';

  const wrap = document.querySelector('.bb-bands');
  if (!wrap) return;

  /* ── Gallery ── */
  const mainImg = document.getElementById('bb-bands-main-img');
  const thumbs = wrap.querySelectorAll('.bb-bands__gallery-thumb');
  const prevBtn = wrap.querySelector('.bb-bands__gallery-arrow--prev');
  const nextBtn = wrap.querySelector('.bb-bands__gallery-arrow--next');
  let currentIdx = 0;

  /* Build mobile dot indicators */
  const galleryMain = wrap.querySelector('.bb-bands__gallery-main');
  let dotsWrap = null;
  if (thumbs.length > 1) {
    dotsWrap = document.createElement('div');
    dotsWrap.className = 'bb-bands__gallery-dots';
    thumbs.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'bb-bands__gallery-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', () => setThumb(i));
      dotsWrap.appendChild(dot);
    });
    if (galleryMain && galleryMain.parentNode) {
      galleryMain.parentNode.insertBefore(dotsWrap, galleryMain.nextSibling);
    }
  }

  function setThumb(idx) {
    if (!thumbs[idx]) return;
    currentIdx = idx;
    const src = thumbs[idx].dataset.src;
    const alt = thumbs[idx].dataset.alt || '';
    mainImg.style.opacity = '0.6';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.alt = alt;
      mainImg.style.opacity = '1';
    }, 100);
    thumbs.forEach(t => t.classList.remove('is-active'));
    thumbs[idx].classList.add('is-active');
    thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    // Update dots
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.bb-bands__gallery-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === idx);
      });
    }
  }

  thumbs.forEach((btn, i) => btn.addEventListener('click', () => setThumb(i)));
  if (prevBtn) prevBtn.addEventListener('click', () => setThumb((currentIdx - 1 + thumbs.length) % thumbs.length));
  if (nextBtn) nextBtn.addEventListener('click', () => setThumb((currentIdx + 1) % thumbs.length));

  /* Touch swipe support for mobile */
  if (galleryMain) {
    let touchStartX = 0;
    galleryMain.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        setThumb(dx < 0
          ? (currentIdx + 1) % thumbs.length
          : (currentIdx - 1 + thumbs.length) % thumbs.length);
      }
    }, { passive: true });
  }

  /* ── Quantity ── */
  const qtyInput = document.getElementById('bb-bands-qty');
  const qtyMinus = document.getElementById('bb-bands-qty-minus');
  const qtyPlus = document.getElementById('bb-bands-qty-plus');

  if (qtyMinus) qtyMinus.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
  });
  if (qtyPlus) qtyPlus.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || 1) + 1;
  });

  /* ── Variant Data (from embedded JSON) ── */
  let productVariants = [];
  const productJsonEl = document.getElementById('bb-bands-product-json');
  if (productJsonEl) {
    try {
      const parsed = JSON.parse(productJsonEl.textContent);
      productVariants = parsed.variants || [];
    } catch(e) {
      console.warn('[bb-bands] Could not parse product JSON', e);
    }
  }

  /* ── Variant Swatches ── */
  const swatches = wrap.querySelectorAll('.bb-bands__swatch');
  const atcBtn = document.getElementById('bb-bands-atc');
  const priceEl = document.getElementById('bb-bands-price');

  let selectedOptions = {};
  swatches.forEach(btn => {
    const idx = btn.dataset.optionIndex;
    if (!(idx in selectedOptions)) {
      if (btn.classList.contains('is-selected')) selectedOptions[idx] = btn.dataset.value;
    }
  });

  swatches.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      const idx = btn.dataset.optionIndex;
      const val = btn.dataset.value;
      selectedOptions[idx] = val;

      // Update UI
      wrap.querySelectorAll(`.bb-bands__swatch[data-option-index="${idx}"]`).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Update label
      const labelSpan = wrap.querySelector(`#bb-bands-option-val-${parseInt(idx) + 1}`);
      if (labelSpan) labelSpan.textContent = val;

      // Find matching variant and update UI
      resolveVariant();
      markUnavailableSwatches();
    });
  });

  function resolveVariant() {
    if (!productVariants.length) return;
    const match = productVariants.find(v => {
      return Object.entries(selectedOptions).every(([idx, val]) => {
        return v.options[parseInt(idx)] === val;
      });
    });
    if (!match) return;

    // Update ATC button variant ID (as integer)
    atcBtn.dataset.variantId = match.id;

    // Update availability
    const isPreorder = (
      match.inventory_management === 'shopify' &&
      match.inventory_policy === 'continue' &&
      match.inventory_quantity <= 0
    );

    if (match.available) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to Cart`;
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold Out';
    }

    // Update price
    if (priceEl) {
      priceEl.textContent = '$' + (match.price / 100).toFixed(2);
    }

    // Update inventory status
    const invText = wrap.querySelector('.bb-bands__inventory');
    if (invText) {
      if (isPreorder) {
        invText.innerHTML = `<span class="bb-bands__dot" style="background:#9A9871;"></span> Pre-Order`;
      } else if (match.available) {
        invText.innerHTML = `<span class="bb-bands__dot bb-bands__dot--in"></span> In Stock`;
      } else {
        invText.innerHTML = `<span class="bb-bands__dot bb-bands__dot--out"></span> Sold Out`;
      }
    }

    // Update pre-order badge
    const preorderBadge = wrap.querySelector('[data-preorder-badge]');
    if (preorderBadge) preorderBadge.classList.toggle('hide', !isPreorder);

    // Update URL
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }
  }

  function markUnavailableSwatches() {
    if (!productVariants.length) return;
    wrap.querySelectorAll('.bb-bands__option').forEach((optEl, optIdx) => {
      optEl.querySelectorAll('.bb-bands__swatch').forEach(btn => {
        const testOptions = Object.assign({}, selectedOptions);
        testOptions[optIdx] = btn.dataset.value;
        const available = productVariants.some(v =>
          Object.entries(testOptions).every(([i, val]) => val === null || v.options[parseInt(i)] === val) && v.available
        );
        btn.disabled = !available;
        btn.style.opacity = available ? '' : '0.35';
      });
    });
  }

  // Run initial unavailable check
  markUnavailableSwatches();

  /* ── Add to Cart ── */
  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      const variantId = atcBtn.dataset.variantId;
      const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      if (!variantId || atcBtn.disabled) return;

      atcBtn.classList.add('is-loading');
      const originalText = atcBtn.innerHTML;
      atcBtn.innerHTML = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      })
        .then(r => {
        // BB: Instant Smart Cart Trigger
        if (window.bbCart) {
          window.bbCart.refreshAndOpen();
        }

          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(() => {
          atcBtn.innerHTML = '✓ Added!';
          setTimeout(() => {
            atcBtn.innerHTML = originalText;
            atcBtn.classList.remove('is-loading');
          }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const cartIcon = document.querySelector('[data-cart-toggle], .cart-toggle, #cart-icon-bubble');
          if (cartIcon) cartIcon.click();
        })
        .catch(() => {
          atcBtn.innerHTML = 'Error — Try Again';
          atcBtn.classList.remove('is-loading');
          setTimeout(() => { atcBtn.innerHTML = originalText; }, 2000);
        });
    });
  }



  /* ── Pairs Well With (quick-add upsell) ── */
  wrap.querySelectorAll('.bb-bands__pairs-item').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId || this.disabled) return;

      const meta = this.querySelector('.bb-bands__pairs-add');
      const originalAddText = meta ? meta.innerHTML : null;
      this.disabled = true;
      this.classList.add('is-loading');
      if (meta) meta.innerHTML = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
        .then(r => {
          if (window.bbCart) { window.bbCart.refreshAndOpen(); }
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(() => {
          if (meta) meta.innerHTML = '✓ Added';
          this.classList.remove('is-loading');
          this.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const cartIcon = document.querySelector('[data-cart-toggle], .cart-toggle, #cart-icon-bubble');
          if (cartIcon) cartIcon.click();
          setTimeout(() => {
            if (meta) meta.innerHTML = originalAddText;
            this.classList.remove('is-added');
            this.disabled = false;
          }, 2000);
        })
        .catch(() => {
          if (meta) meta.innerHTML = 'Error';
          this.classList.remove('is-loading');
          setTimeout(() => {
            if (meta) meta.innerHTML = originalAddText;
            this.disabled = false;
          }, 2000);
        });
    });
  });

    /* ── Accordion ── */
  wrap.querySelectorAll('.bb-bands__accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.bb-bands__accordion-item');
      item.classList.toggle('is-open');
    });
  });

  /* ── Sticky ATC Bar ── */
  const stickyBar = document.getElementById('bb-bands-sticky');
  const stickyAtcBtn = document.getElementById('bb-bands-sticky-atc');
  const stickyPriceEl = document.getElementById('bb-bands-sticky-price');

  if (stickyBar && atcBtn) {
    // Show sticky bar when main ATC scrolls out of view
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );
    observer.observe(atcBtn);

    // Keep sticky price in sync with variant changes
    if (stickyPriceEl && priceEl) {
      const priceObserver = new MutationObserver(() => {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Keep sticky variant ID in sync
    if (stickyAtcBtn) {
      const variantObserver = new MutationObserver(() => {
        stickyAtcBtn.dataset.variantId = atcBtn.dataset.variantId;
      });
      variantObserver.observe(atcBtn, { attributes: true, attributeFilter: ['data-variant-id'] });

      // Sticky ATC click handler
      stickyAtcBtn.addEventListener('click', () => {
        const variantId = stickyAtcBtn.dataset.variantId || atcBtn.dataset.variantId;
        const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
        if (!variantId || stickyAtcBtn.disabled) return;

        stickyAtcBtn.disabled = true;
        const originalText = stickyAtcBtn.textContent;
        stickyAtcBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(r => r.json())
          .then(() => {
            stickyAtcBtn.textContent = '\u2713 Added!';
            setTimeout(() => {
              stickyAtcBtn.textContent = originalText;
              stickyAtcBtn.disabled = false;
            }, 1800);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            const cartIcon = document.querySelector('[data-cart-toggle], .cart-toggle, #cart-icon-bubble');
            if (cartIcon) cartIcon.click();
          })
          .catch(() => {
            stickyAtcBtn.textContent = 'Error — Try Again';
            setTimeout(() => {
              stickyAtcBtn.textContent = originalText;
              stickyAtcBtn.disabled = false;
            }, 2000);
          });
      });
    }
  }

})();


